import { combineReducers } from "redux";
import changeCardReducer from "./changeCardReducer";


const rootReducer = combineReducers({
    changeCardReducer
})

export default rootReducer